import { FlashMessage } from '@pegasus/ui-flashmessages';

import { ClientFlashMessagesState } from './reducers';
import { NAMESPACE } from './index';

export const getClientFlashMessages = (state: ClientFlashMessagesState): FlashMessage[] =>
    state[NAMESPACE].view.messages || [];
